var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("CargoMsg.Cargo_SubscribeToDataAlerts"),
        width: "1030px",
        "close-on-click-modal": false,
        "destroy-on-close": true,
        top: "5vh",
        "custom-class": "details-view reminder-form"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        },
        close: _vm.close
      }
    },
    [
      _c(
        "div",
        { staticClass: "main-content" },
        [
          _c(
            "el-tabs",
            {
              staticStyle: { width: "100%" },
              attrs: { type: "card" },
              model: {
                value: _vm.tabName,
                callback: function($$v) {
                  _vm.tabName = $$v
                },
                expression: "tabName"
              }
            },
            [
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("SystemMaintenance.DataService"),
                    name: "dataService",
                    lazy: true
                  }
                },
                [
                  _c("div", { staticStyle: { width: "fit-content" } }, [
                    _c("div", { staticStyle: { display: "flex" } }, [
                      _c(
                        "div",
                        { staticClass: "section form-column content-wrapper" },
                        [
                          _c(
                            "el-form",
                            {
                              attrs: {
                                disabled: _vm.readonly,
                                "label-width": "100px",
                                "label-position": "left"
                              }
                            },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_WarningSwitch"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      model: {
                                        value: _vm.form.open,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "open", $$v)
                                        },
                                        expression: "form.open"
                                      }
                                    },
                                    [
                                      _c("el-radio", { attrs: { label: 1 } }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("CargoMsg.Cargo_StartAlert")
                                          )
                                        )
                                      ]),
                                      _c("el-radio", { attrs: { label: 0 } }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("CargoMsg.Cargo_CloseAlert")
                                          )
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_NodPushSettings"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      model: {
                                        value: _vm.form.userConfigOpen,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "userConfigOpen",
                                            $$v
                                          )
                                        },
                                        expression: "form.userConfigOpen"
                                      }
                                    },
                                    [
                                      _c("el-radio", { attrs: { label: 1 } }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "CargoMsg.Cargo_EnablePersonalSettings"
                                            )
                                          )
                                        )
                                      ]),
                                      _c("el-radio", { attrs: { label: 0 } }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "CargoMsg.Cargo_ClosePersonalSettings"
                                            )
                                          )
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_WarningConditions"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "el-checkbox-group",
                                    {
                                      staticStyle: { width: "405px" },
                                      model: {
                                        value: _vm.ruleItem,
                                        callback: function($$v) {
                                          _vm.ruleItem = $$v
                                        },
                                        expression: "ruleItem"
                                      }
                                    },
                                    _vm._l(_vm.warningTypes, function(
                                      item,
                                      index
                                    ) {
                                      return _c(
                                        "el-checkbox",
                                        {
                                          key: index,
                                          attrs: { label: item.code }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.isZh
                                                ? item.chineseName
                                                : item.englishName
                                            )
                                          )
                                        ]
                                      )
                                    }),
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "Message.PortOfDepartureUpdate"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "el-checkbox-group",
                                    {
                                      staticStyle: { width: "405px" },
                                      model: {
                                        value: _vm.ruleItem,
                                        callback: function($$v) {
                                          _vm.ruleItem = $$v
                                        },
                                        expression: "ruleItem"
                                      }
                                    },
                                    [
                                      _vm._l(_vm.portAreaReminder, function(
                                        item,
                                        index
                                      ) {
                                        return _c(
                                          "el-checkbox",
                                          {
                                            key: index,
                                            attrs: { label: item.code }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.isZh
                                                  ? item.chineseName
                                                  : item.englishName
                                              )
                                            )
                                          ]
                                        )
                                      }),
                                      _c("br"),
                                      _vm._l(_vm.nodeAlertTypes, function(
                                        item,
                                        index
                                      ) {
                                        return _c(
                                          "el-checkbox",
                                          {
                                            key: index + 1,
                                            attrs: { label: item.code }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.isZh
                                                  ? item.chineseName
                                                  : item.englishName
                                              )
                                            )
                                          ]
                                        )
                                      })
                                    ],
                                    2
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_ShipPlanReminderMethod"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      on: {
                                        change: _vm.changeVesselReminderMethod
                                      },
                                      model: {
                                        value: _vm.form.vesselReminderMethod,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "vesselReminderMethod",
                                            $$v
                                          )
                                        },
                                        expression: "form.vesselReminderMethod"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        {
                                          staticStyle: {
                                            "margin-right": "5px"
                                          },
                                          attrs: { label: 0 }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_ShipNameAndVoyage"
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-radio",
                                        {
                                          staticStyle: {
                                            "margin-right": "5px"
                                          },
                                          attrs: { label: 1 }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("CargoMsg.Cargo_Job"))
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "Message.DestinationPortUpdate"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "el-checkbox-group",
                                    {
                                      staticStyle: { width: "405px" },
                                      model: {
                                        value: _vm.ruleItem,
                                        callback: function($$v) {
                                          _vm.ruleItem = $$v
                                        },
                                        expression: "ruleItem"
                                      }
                                    },
                                    _vm._l(
                                      _vm.DestinationPortNodeAlertTypes,
                                      function(item, index) {
                                        return _c(
                                          "el-checkbox",
                                          {
                                            key: index,
                                            attrs: { label: item.code }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.isZh
                                                  ? item.chineseName
                                                  : item.englishName
                                              )
                                            )
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_AutoIgnoreMode"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      on: { input: _vm.selectType },
                                      model: {
                                        value: _vm.form.ignoreType,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "ignoreType", $$v)
                                        },
                                        expression: "form.ignoreType"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticStyle: { display: "flex" } },
                                        [
                                          _c(
                                            "el-radio",
                                            {
                                              staticStyle: {
                                                "margin-top": "5px"
                                              },
                                              attrs: { label: 1 }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "CargoMsg.Cargo_EarlyTimedIgnore"
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _c("el-input-number", {
                                            staticStyle: {
                                              width: "120px !important",
                                              "margin-right": "5px"
                                            },
                                            attrs: {
                                              disabled:
                                                _vm.form.ignoreType === 0,
                                              "controls-position": "right",
                                              oninput:
                                                "value=value.replace(/[^\\d]/g,'')"
                                            },
                                            model: {
                                              value: _vm.form.ignoreTime,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "ignoreTime",
                                                  $$v
                                                )
                                              },
                                              expression: "form.ignoreTime"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "margin-top": "5px"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "CargoMsg.Cargo_AutomaticallyIgnoreAfterHours"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-radio",
                                        {
                                          staticStyle: { "margin-top": "5px" },
                                          attrs: { label: 0 }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_TurnOffAutoIgnore"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("CargoMsg.Cargo_WarningLevel")
                                  }
                                },
                                _vm._l(_vm.levels, function(item) {
                                  return _c(
                                    "el-radio-group",
                                    {
                                      key: item.code,
                                      model: {
                                        value: _vm.form.level,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "level", $$v)
                                        },
                                        expression: "form.level"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        {
                                          staticStyle: {
                                            "margin-right": "5px"
                                          },
                                          attrs: { label: item.code }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.isZh
                                                ? item.chineseName
                                                : item.englishName
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                }),
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("CargoMsg.Cargo_RemarksInfo")
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { type: "textarea" },
                                    model: {
                                      value: _vm.form.remark,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "remark", $$v)
                                      },
                                      expression: "form.remark"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "BusinessIntelligence.businessIntelligenceChart.warmPrompt"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { width: "380px" } },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "CargoMsg.Cargo_DataServiceReminderWarningOne"
                                            )
                                          )
                                        )
                                      ]),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "CargoMsg.Cargo_DataServiceReminderWarning"
                                            )
                                          )
                                        )
                                      ]),
                                      _c(
                                        "a",
                                        {
                                          staticStyle: { color: "#1f75d5" },
                                          on: { click: _vm.learnMore }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_ClickToLearnMore"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "section form-column content-wrapper" },
                        [
                          _c(
                            "el-form",
                            {
                              attrs: {
                                disabled: _vm.readonly,
                                "label-width": "100px",
                                "label-position": "left"
                              }
                            },
                            [
                              _c(
                                "el-form-item",
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: { color: "#1F75D5" },
                                      attrs: { slot: "label" },
                                      slot: "label"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "SystemMaintenance.ConfigurationName"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _c("el-input", {
                                    staticStyle: { width: "300px" },
                                    model: {
                                      value: _vm.form.configureName,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "configureName", $$v)
                                      },
                                      expression: "form.configureName"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c("span", { staticClass: "title" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "CargoMsg.Cargo_DocumentNotification"
                                    )
                                  )
                                )
                              ]),
                              _c(
                                "div",
                                { staticStyle: { margin: "10px" } },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      model: {
                                        value: _vm.form.notifyJobType,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "notifyJobType",
                                            $$v
                                          )
                                        },
                                        expression: "form.notifyJobType"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        {
                                          staticStyle: {
                                            "margin-bottom": "5px"
                                          },
                                          attrs: { label: 0 }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_NoticeOfEachBill"
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c("el-radio", { attrs: { label: 1 } }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "CargoMsg.Cargo_NoNoticeOfTickets"
                                            )
                                          )
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c("span", { staticClass: "title" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "CargoMsg.Cargo_SetAlertNotificationObject"
                                    )
                                  )
                                )
                              ]),
                              _c(
                                "div",
                                { staticStyle: { "margin-left": "10px" } },
                                [
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "el-checkbox",
                                        {
                                          model: {
                                            value: _vm.hasDesignatedPost,
                                            callback: function($$v) {
                                              _vm.hasDesignatedPost = $$v
                                            },
                                            expression: "hasDesignatedPost"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_DesignatedPost"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-checkbox-group",
                                    {
                                      staticStyle: { "margin-left": "10px" },
                                      attrs: {
                                        disabled: !_vm.hasDesignatedPost
                                      },
                                      model: {
                                        value: _vm.notifierRoles,
                                        callback: function($$v) {
                                          _vm.notifierRoles = $$v
                                        },
                                        expression: "notifierRoles"
                                      }
                                    },
                                    _vm._l(_vm.roles, function(item, index) {
                                      return _c(
                                        "el-checkbox",
                                        {
                                          key: index,
                                          staticStyle: { "margin-top": "10px" },
                                          attrs: { label: item.code }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.isZh
                                                ? item.chineseName
                                                : item.englishName
                                            )
                                          )
                                        ]
                                      )
                                    }),
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticStyle: { "margin-top": "10px" } },
                                    [
                                      _c(
                                        "el-checkbox",
                                        {
                                          on: {
                                            change: function($event) {
                                              _vm.notifierIds = []
                                            }
                                          },
                                          model: {
                                            value: _vm.hasNotifierIds,
                                            callback: function($$v) {
                                              _vm.hasNotifierIds = $$v
                                            },
                                            expression: "hasNotifierIds"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_DesignatedPersonnel"
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c("cargo-advance-select", {
                                        staticStyle: {
                                          width: "205px",
                                          "margin-top": "10px"
                                        },
                                        attrs: {
                                          "select-type":
                                            _vm.selectTypeNames.basic_data_User,
                                          fields: ["chineseName"],
                                          disabled: !_vm.hasNotifierIds,
                                          "callback-params": {
                                            key: "userList"
                                          },
                                          "callback-method-type": "value",
                                          "tag-value": "userId",
                                          "tag-name": "chineseName",
                                          "filter-tag-names": ["chineseName"],
                                          "method-params": {
                                            pageSize: 1000000,
                                            active: true,
                                            hasRole: true
                                          },
                                          "default-multiple-value":
                                            _vm.notifierIds,
                                          multiple: "",
                                          filterable: "",
                                          "options-width": "230px"
                                        },
                                        on: {
                                          parentCallBack: function(p) {
                                            _vm.notifierIds = p.value
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "title",
                                  staticStyle: { "margin-top": "10px" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_ReminderModes")
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      model: {
                                        value: _vm.enableMail,
                                        callback: function($$v) {
                                          _vm.enableMail = $$v
                                        },
                                        expression: "enableMail"
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("Viewer.email")))]
                                  ),
                                  _c(
                                    "el-checkbox",
                                    {
                                      model: {
                                        value: _vm.enableWeChat,
                                        callback: function($$v) {
                                          _vm.enableWeChat = $$v
                                        },
                                        expression: "enableWeChat"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("CargoMsg.Cargo_Wechat"))
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-checkbox",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.showEnableEnterpriseWechat,
                                          expression:
                                            "showEnableEnterpriseWechat"
                                        }
                                      ],
                                      model: {
                                        value: _vm.enableEnterpriseWechat,
                                        callback: function($$v) {
                                          _vm.enableEnterpriseWechat = $$v
                                        },
                                        expression: "enableEnterpriseWechat"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "CargoMsg.Cargo_EnterpriseWechat"
                                          ) +
                                            _vm.$t(
                                              "CargoMsg.Cargo_EnterpriseWechat2DataServiceReminder"
                                            )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.commitHandler } },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
          ),
          _c("el-button", { on: { click: _vm.close } }, [
            _vm._v(_vm._s(_vm.$t("Message.Cancel")))
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }